import React, { Component } from "react";
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";

class About extends Component {
  handleHomeButton = () => {
    window.location.href = "/sampleHome";
  };

  renderAbout = () => {
    return (
      <div className="grid grid-cols-2 mb-9 mt-10">
        <div className="text-left mb-14 pr-8">
          <h2 className="text-2xl font-normal text-maroon">
            About</h2>
          <p className="font-normal mt-2 text-xl text-justify">
            At Novelology, we're passionate about connecting avid readers
            through our social media book platform. Our platform offers
            numerous features designed to enhance your reading experience
            and foster lively discussions within the book community. Our
            inspiration stemmed from a desire to create a space where the
            book community could thrive. To learn more about our features,
            click{" "}
            <button type="button" onClick={this.handleHomeButton}>
              Here
            </button>
          </p>
        </div>

        <div className="flex flex-row justify-center items-center pl-10">
          <img
            alt="About Image"
            loading="lazy"
            srcSet={require("../assets/best-seller.png")}
            className="flex-1 w-full mr-2 rounded-xl shadow-sm w-[19em] h-[19em]"
          />
        </div>
      </div>
    );
  };

  renderGoals = () => {
    return (
      <div className="grid grid-cols-2 mb-9">
        <div className="flex flex-row justify-center items-center pr-10">
          <img
            alt="Goals Image"
            loading="lazy"
            srcSet={require("../assets/goals.jpg")}
            className="flex-1 w-full mr-2 rounded-xl shadow-sm w-[19em] h-[19em]"
          />
        </div>

        <div className="text-right mb-14 pl-8">
          <h2 className="text-2xl font-normal text-maroon">
            Goals</h2>
          <p className="font-normal mt-2 text-xl text-justify">
            Our goal is to create an engaging atmosphere where readers and
            writers can interact, have interesting conversations, and share
            their best book memories with one another. Our mission is to
            motivate readers to explore new literary works, make
            personalized book lists, and take part in reading challenges.
            Drawing inspiration from the concept of existing book
            communities, we strive to create a unique space that emphasizes
            community engagement and social interaction among bibliophiles.
          </p>
        </div>
      </div>
    );
  };

  renderMotivation = () => {
    return (
      <div className="grid grid-cols-2 mb-9">
        <div className="text-left mb-14 pr-8">
          <h2 className="text-2xl font-normal text-maroon">
            Motivation</h2>
          <p className="font-normal mt-2 text-xl text-justify">
            Our inspiration for Novelology stemmed from a desire to create a
            space where the book community could thrive. By combining the
            features of a social media platform with a book-centric
            community, our aim is to provide an engaging platform where
            users can connect, share, and explore their love for literature.
          </p>
        </div>

        <div className="flex flex-row justify-center items-center pl-10">
          <img
            alt="Motivation Image"
            loading="lazy"
            srcSet={require("../assets/motivations.jpg")}
            className="flex-1 w-full mr-2 rounded-xl shadow-sm w-[19em] h-[19em]"
          />
        </div>
      </div>
    );
  };

  renderContributors = () => {
    return (
      <div className="text-center mb-14">
        <h2 className="text-2xl font-normal text-maroon">
          Contributors</h2>
        <p className="font-normal mt-2 text-xl text-justify">
          Novelology was founded and created by Rishitha Bura, Nathan Race,
          Victor Martinez, Mutahhara Jannat, and Jad Aoun, who all played a
          critical role in bringing Novelology to life.
        </p>
      </div>
    );
  };

  render() {
    return (
      <div className="flex flex-col h-screen bg-gray-100 ">
        <div className="flex-1 bg-maroon bg-opacity-80 flex flex-col justify-center items-center">
          <h1 className="text-5xl text-pink-100 mt-16">
            The Novelology Story</h1>
          <h2 className="text-xl italic text-white mt-10 font-normal">
            Turning pages, Uncovering Connections
          </h2>
          <h2 className="text-xl italic text-white mt-10 font-normal">
          
          </h2>
        </div>

        <div className="flex-1 bg-gray-100 mt-10 px-16">
          <div className="flex flex-col ">
            {this.renderAbout()}
            {this.renderGoals()}
            {this.renderMotivation()}
            {this.renderContributors()}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default About;